import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetInstalledDevicesByDeviceIdQueryVariables = Types.Exact<{
  device_id: Types.Scalars['uuid']['input'];
  property_ids?: Types.InputMaybe<Array<Types.Scalars['uuid']['input']> | Types.Scalars['uuid']['input']>;
}>;


export type GetInstalledDevicesByDeviceIdQuery = { __typename?: 'query_root', products_by_pk?: { __typename?: 'products', id: any, name: string, description: string, sku?: string | null, make: string, model: string, retail_price?: any | null, product_notes?: string | null, photo_link?: string | null, product_category: { __typename?: 'product_categories', name: string, label: string }, product_attachments: Array<{ __typename?: 'product_attachments', id: any, photo_link?: string | null, document_link?: string | null, video_link?: string | null, audio_link?: string | null, site_link?: string | null, transcription?: string | null, name?: string | null, transcribed: boolean, type?: string | null, description?: string | null }>, installed_products: Array<{ __typename?: 'installed_products', id: any, location?: string | null, building_id?: any | null, floor_id?: any | null, room_id?: any | null, in_room_location?: any | null, photo_link?: string | null, installation_date: any, product_serial?: string | null, device_status?: string | null, partner_disconnected_at?: any | null, partner_association?: string | null, building?: { __typename?: 'buildings', id: any, name: string } | null, floor?: { __typename?: 'floors', id: any, name: string } | null, room?: { __typename?: 'rooms', id: any, name: string } | null, property?: { __typename?: 'properties', id: any, name: string } | null }>, product_guides: Array<{ __typename?: 'product_guides', guide?: { __typename?: 'guides', id: any, title?: string | null } | null }> } | null };


export const GetInstalledDevicesByDeviceIdDocument = gql`
    query getInstalledDevicesByDeviceId($device_id: uuid!, $property_ids: [uuid!]) {
  products_by_pk(id: $device_id) {
    id
    name
    description
    sku
    product_category {
      name
      label
    }
    make
    model
    retail_price
    product_notes
    photo_link
    product_attachments {
      id
      photo_link
      document_link
      video_link
      audio_link
      site_link
      transcription
      name
      transcribed
      type
      description
    }
    installed_products(
      where: {property_id: {_in: $property_ids}, _or: [{handover: {status: {_eq: "PUBLISHED"}}}, {handover_id: {_is_null: true}}]}
    ) {
      id
      location
      building_id
      floor_id
      room_id
      in_room_location
      building {
        id
        name
      }
      floor {
        id
        name
      }
      room {
        id
        name
      }
      photo_link
      property {
        id
        name
      }
      installation_date
      product_serial
      device_status
      partner_disconnected_at
      partner_association
    }
    product_guides(where: {guide: {status: {_eq: "published"}}}) {
      guide {
        id
        title
      }
    }
  }
}
    `;

/**
 * __useGetInstalledDevicesByDeviceIdQuery__
 *
 * To run a query within a React component, call `useGetInstalledDevicesByDeviceIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstalledDevicesByDeviceIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstalledDevicesByDeviceIdQuery({
 *   variables: {
 *      device_id: // value for 'device_id'
 *      property_ids: // value for 'property_ids'
 *   },
 * });
 */
export function useGetInstalledDevicesByDeviceIdQuery(baseOptions: Apollo.QueryHookOptions<GetInstalledDevicesByDeviceIdQuery, GetInstalledDevicesByDeviceIdQueryVariables> & ({ variables: GetInstalledDevicesByDeviceIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstalledDevicesByDeviceIdQuery, GetInstalledDevicesByDeviceIdQueryVariables>(GetInstalledDevicesByDeviceIdDocument, options);
      }
export function useGetInstalledDevicesByDeviceIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstalledDevicesByDeviceIdQuery, GetInstalledDevicesByDeviceIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstalledDevicesByDeviceIdQuery, GetInstalledDevicesByDeviceIdQueryVariables>(GetInstalledDevicesByDeviceIdDocument, options);
        }
export function useGetInstalledDevicesByDeviceIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInstalledDevicesByDeviceIdQuery, GetInstalledDevicesByDeviceIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInstalledDevicesByDeviceIdQuery, GetInstalledDevicesByDeviceIdQueryVariables>(GetInstalledDevicesByDeviceIdDocument, options);
        }
export type GetInstalledDevicesByDeviceIdQueryHookResult = ReturnType<typeof useGetInstalledDevicesByDeviceIdQuery>;
export type GetInstalledDevicesByDeviceIdLazyQueryHookResult = ReturnType<typeof useGetInstalledDevicesByDeviceIdLazyQuery>;
export type GetInstalledDevicesByDeviceIdSuspenseQueryHookResult = ReturnType<typeof useGetInstalledDevicesByDeviceIdSuspenseQuery>;
export type GetInstalledDevicesByDeviceIdQueryResult = Apollo.QueryResult<GetInstalledDevicesByDeviceIdQuery, GetInstalledDevicesByDeviceIdQueryVariables>;